<template>
  <div class="couponPanel">
    <div v-if="!isShowEmptyNote">
      <div class="title">恭喜你获得以下奖励</div>
      <div class="couponList">
        <CouponItem
          v-for="couponItem in renderCouponList"
          :data="couponItem"
          :key="couponItem.id"
          @getCouponDetail="getCouponDetail"
          :isShowRuleBtn="isShowRule"
          :isShowToUseBtn="isShowToUseButton"
          @reportEvent="handleReportEvent"
        />
      </div>
      <div
        v-if="isShowCollapse"
        class="collapseSwitch"
        @click="handleCollapseSwitch"
      >
        {{ collapseSwitchText }}
        <img
          src="../assets/images/arrow_down_white.png"
          class="collapseIcon"
          :class="{ reverse: isCollapsed }"
        />
      </div>
    </div>
    <div class="empty" v-if="isShowEmptyNote">
      <p>{{ emptyNoteText() }}</p>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import CouponItem from './CouponItem';
import { BUSINESS_TYPE_NAME } from '@/components/templates/helper';

const ERROR_MAP = {
  NoTaskExcute: '您已经领过了哟，去其它活动看看吧~', //没有任务可执行
  AccessActFail: '您无法参与此活动，去其它活动看看吧~', //人群准入失败
  TaskRiskFail: '您无法参与此活动，去其它活动看看吧~', // 任务风控失败
  DistributeRewardFail: '活动太火爆，已领完，去其他活动看看吧~~' //派券失败
};

const LENGTH_LIMIT = 5;
export default {
  components: { CouponItem },
  props: {
    moduleName: {
      type: String,
      require: true
    },
    isListCollapsed: {
      type: Boolean,
      default: false
    },
    isShowToUseButton: {
      type: Boolean,
      default: false
    },
    isShowRule: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isCollapsed: true
    };
  },
  computed: {
    ...mapState('app', {
      couponListData: function(state) {
        return state[this.moduleName].actData.couponRewards || [];
      },
      actResult: function(state) {
        return state[this.moduleName].actData.result;
      },
      startTime: function(state) {
        return state[this.moduleName].actData.startTime;
      },
      endTime: function(state) {
        return state[this.moduleName].actData.endTime;
      },
      currentTime: function(state) {
        return state[this.moduleName].actData.currentTime;
      },
      businessLine: function(state) {
        return state[this.moduleName].actData.businessLine;
      }
    }),
    isNotInActTime() {
      const now = this.currentTime;
      return now < this.startTime || now > this.endTime;
    },
    isShowEmptyNote() {
      return (
        this.actResult !== 'SUCCESS' ||
        this.isNotInActTime ||
        this.couponListData.length === 0
      );
    },
    isShowCollapse() {
      return this.isListCollapsed && this.couponListData.length > LENGTH_LIMIT;
    },
    collapseSwitchText() {
      return this.isCollapsed ? '查看更多' : '收起';
    },
    renderCouponList() {
      if (this.isShowCollapse && this.isCollapsed) {
        return this.couponListData.slice(0, LENGTH_LIMIT);
      }
      return this.couponListData;
    }
  },
  methods: {
    ...mapActions('app', {
      getCouponDetail: function(dispatch, ...props) {
        return dispatch(`${this.moduleName}/getCouponDetail`, ...props);
      }
    }),
    handleCollapseSwitch() {
      this.isCollapsed = !this.isCollapsed;
      this.reportCollapseSwitch(this.isCollapsed);
    },
    emptyNoteText() {
      if (this.currentTime < this.startTime) {
        return '活动未开始';
      }
      if (this.currentTime > this.endTime) {
        return '活动已结束';
      }
      if (this.actResult !== 'SUCCESS') {
        return (
          ERROR_MAP[this.actResult] || '活动太火爆，已领完，去其他活动看看吧~~'
        );
      }
    },
    handleReportEvent(data) {
      this.$emit('reportEvent', {
        ...data,
        activity_business_line:
          BUSINESS_TYPE_NAME[this.businessLine] ||
          (Number(this.businessLine) === 8 ? '小拉' : this.businessLine)
      });
    },
    reportCollapseSwitch(isCollapsed) {
      this.handleReportEvent({
        event: 'column_reward_click',
        module_name: isCollapsed ? '收起' : '查看更多'
      });
    },
    reportExpo() {
      const ERROR_CODE_MAP = {
        NoTaskExcute: '没有任务可执行',
        AccessActFail: '人群准入失败',
        TaskRiskFail: ' 任务风控失败',
        DistributeRewardFail: '派券失败'
      };
      const failReason = this.isShowEmptyNote
        ? ERROR_CODE_MAP[this.actResult] || this.emptyNoteText()
        : undefined;
      this.handleReportEvent({
        event: 'column_reward_expo',
        page_name: this.isShowEmptyNote ? '领券缺省组件' : '领券组件',
        fail_reason: failReason
      });
    }
  },
  mounted() {
    this.reportExpo();
  }
};
</script>
<style lang="less" scoped>
.couponPanel {
  padding-top: 40px;
  .title {
    text-align: center;
    font-size: 36px;
    color: #ffffff;
    margin-bottom: 40px;
  }

  .collapseSwitch {
    margin-top: 20px;
    color: #ffffff;
    font-size: 28px;
    text-align: center;

    .collapseIcon {
      width: 22px;
      height: 12px;
      &.reverse {
        transform-origin: center;
        transform: rotate(180deg);
      }
    }
  }
  .empty {
    .fc;
    margin-top: 30px;
    padding-top: 50px;
    padding-bottom: 50px;
    width: 702px;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.09);
    p {
      font-size: 30px;
      color: #8c8c8c;
    }
  }
}
</style>
